import React from "react";
import { TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table } from "semantic-ui-react";

const TableExampleSelectableInvertedRow = (prop) => (
    <Table celled inverted selectable>
        <TableHeader>
            <TableRow>
                <TableHeaderCell>Name</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
           
            </TableRow>
        </TableHeader>

        <TableBody>
            {prop.tables.map(function (tbl, i) {
                if(tbl.playing>0){
                return (
                    <TableRow key={i} onClick={() =>  prop.setTableid(tbl.ID)}>
                        <TableCell>{tbl.ID}</TableCell>
                        <TableCell>{tbl.playing}</TableCell>
                 
                    </TableRow>
                );}
            })}
        </TableBody>
    </Table>
);

export default TableExampleSelectableInvertedRow;
